(<template>
  <main>
    <div class="http-status-full-wrapper">
      <div class="http-status-value">
        404
      </div>
      <p class="http-status-message"
         v-html="errorMessage"></p>
      <figure class="http-status-logo-cont">
        <img src="data:image/svg+xml;base64,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">
      </figure>
    </div>
  </main>
</template>)

<script>
  export default {
    computed: {
      errorMessage() {
        const resolvedHref = this.$router.resolve(this.$makeRoute({name: 'SignIn'})).href;
        const infoPortalLink = this.$getString('domainData', 'infoPortalLink');
        const template = this.$gettext('Sorry, the page you are looking for does not exist. Please continue to our <a class="http-status-message--link" href="%{link}">home page</a> or to your <a class="http-status-message--link" href="%{dashboard}">dashboard</a>');
        return this.$gettextInterpolate(template, {link: infoPortalLink, dashboard: resolvedHref});
      }
    }
  };
</script>

<style>
  .http-status-message .http-status-message--link {
    color: #000;
    text-decoration: underline;
  }
</style>

<style scoped>
  * {
    box-sizing: border-box;
    margin: 0;
    padding: 0;
  }

  html,
  body {
    display: block;
    width: 100%;
    height: 100%;
    font-family: "open Sans", sans-serif;
  }

  .http-status-full-wrapper {
    width: 100%;
    min-height: 100%;
    padding-top: 100px;
    text-align: center;
  }

  .http-status-logo-cont {
    padding-top: 40px;
  }

  .http-status-logo-cont img {
    width: 160px;
    height: 30px;
  }

  .http-status-value {
    display: inline-block;
    border-bottom: 3px solid var(--color-primary);
    color: var(--color-primary);
    font-size: 200px;
    line-height: 246px;
  }

  .http-status-message {
    display: block;
    width: 100%;
    max-width: 475px;
    margin: 25px auto 0;
    font-size: 18px;
  }

  @media (max-width: 768px) {
    .http-status-full-wrapper {
      padding-top: 70px;
    }

    .http-status-value {
      font-size: 100px;
      line-height: 136px;
    }

    .http-status-message {
      max-width: 300px;
      margin-top: 20px;
      font-size: 14px;
    }
  }
</style>
